import { render } from "./FooterMenuNewsletter.vue?vue&type=template&id=2c53f332"
import script from "./FooterMenuNewsletter.vue?vue&type=script&lang=js"
export * from "./FooterMenuNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__